/*
 *
 * CommunicationNewMobile actions
 *
 */

import {
  FLUSH_STATE,
  UPDATE_COMMUNICATION,
  UPDATE_COMMUNICATION_SUCCESS,
  UPDATE_COMMUNICATION_ERROR,
} from './constants';

export function flushState() {
  return {
    type: FLUSH_STATE,
  };
}

// Update for Single User
export function updateCommunication(itemDetail) {
  return {
    type: UPDATE_COMMUNICATION,
    itemDetail,
  };
}
export function updateCommunicationSuccess(itemDetail) {
  return {
    type: UPDATE_COMMUNICATION_SUCCESS,
    itemDetail,
  };
}

export function updateCommunicationError(updateError) {
  return {
    type: UPDATE_COMMUNICATION_ERROR,
    updateError,
  };
}
